
import { FunctionComponent, ReactElement } from "react";
import { Input, Typography } from 'antd';
import { Controller, useFormContext } from "react-hook-form";

const {Text, Paragraph} = Typography

type Props = {
  name: string
  label?: string
  description?: string
  value?: string
  placeholder?: string
  icon?: string
  disable?: boolean
  mandatory?: boolean
  onChange?: (value?: any) => void;
  onBlur?: VoidFunction;
};
export const ARIFieldInput: FunctionComponent<Props> = ({
  name,
  icon,
  placeholder,
  label,
  description,
  mandatory,
  ...props
}): ReactElement => {
  const { control, formState: { errors } } = useFormContext();
  // TODO: serraCarles: Verify lodash librery to simplify this code
  const getError = (name: string, errors: any) => {
    const keys = name.split('.');
    let error = errors;
    for (const key of keys) {
      if (error[key]) {
        error = error[key];
      } else {
        return undefined;
      }
    }
    return error.message;
  };
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, onBlur } }) => (
        <div style={{marginTop: '2%'}}>
          <Text><strong>{`${label}`}{mandatory && (<Text> * </Text>)}</strong></Text>
          {description && (<Paragraph style={{color:'grey'}}> {`${description}`} </Paragraph>)}
            <Input
              placeholder={placeholder && placeholder}
              disabled={props.disable}
              onBlur={onBlur}
              variant="filled"
              value={value}
              onChange={value => {
                onChange( value.target.value );
                props.onChange && props.onChange(value.target.value);
                
              }}
            />
          {getError(name, errors) && <Text style={{ color: 'red' }}>{getError(name, errors)}</Text>}
          </div>
      )}
    />
  );
};
